







import { Component, Vue, Prop } from "vue-property-decorator";
import {
  Company,
  getAllCompanies,
  updateFavoriteCompany
} from "@/api/company-api";

import CompanyList from "@/templates/EndUserList.vue";

import GroupFilter from "@/entities/group-filter";

@Component({
  components: {
    CompanyList
  }
})
export default class CompanyListPage extends Vue {
  @Prop({ default: "" }) companyType!: string;

  select({ id }: { id: number }) {
    const params = { id: String(id) };
    this.$router.push({ name: "enduser-show", params });
  }

  create() {
    this.$router.push({ name: "enduser-new" });
  }

  search(query: string) {
    this.query = query;
  }

  filter(role: string) {
    this.companyRole = role;
  }

  async updateFavorite(companyId: number, favorite: boolean) {
    await updateFavoriteCompany(companyId, favorite);
    await this.initCompanies();
  }

  get companies() {
    return this.rawCompanies.filter(c => this.searchFilter.isSatisfied(c));
  }

  private rawCompanies: Company[] = [];
  private query = "";
  private companyRole: string = "all";

  private get searchFilter() {
    return new GroupFilter({
      query: this.query,
      role: this.companyRole
    });
  }

  private created() {
    this.initCompanies();
  }

  private async initCompanies() {
    this.rawCompanies = await getAllCompanies({ companyType: "3" });
  }
}
